'use client';
import { RegisterOptions, FieldValues, FieldPath } from 'react-hook-form';
import { t } from 'i18next';

export const getDefaultRequiredErrorMessage = (fieldDescription: string) => `${t('Please enter')} ${fieldDescription.toLowerCase()}`;

export const getDefaultValidators: <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>( // TODO: Check type, simplify if possible
  fieldDescription: string,
  validators: RegisterOptions<TFieldValues, TName>,
) => RegisterOptions<TFieldValues, TName> = (fieldDescription, validators) => ({
  ...validators,
  ...validators.required && {
    required: (typeof validators.required === 'string') ? validators.required : getDefaultRequiredErrorMessage(fieldDescription),
  },
});

export const EMAIL_REGEX = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/; // Taken from backend
export const PASSWORD_REGEX = /(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*()+=\-?;,./{}|":<>[\]\\' ~_]).{8,}/; // Taken from backend

const commonSpecialCharacters = '!~@#$%^&*-_=+,.?';
const getSpecialCharacter = () => commonSpecialCharacters[Math.floor(Math.random() * (commonSpecialCharacters.length - 1))];
const getRandomCharacters = (length: number) => window.crypto.randomUUID().slice(0, length);

export const generateRandomPassword = () => {
  let password = [
    getRandomCharacters(6).toUpperCase(), // 6 letters/numbers, uppercase
    Math.floor(Math.random() * 9), // 1 number
    getSpecialCharacter(), // 1 special character
  ].join('');
  if (!new RegExp(PASSWORD_REGEX).test(password)) {
    password = generateRandomPassword();
  }
  return password;
};
